const urls = {
    VESSEL_SUMMARY_IMPORT_FROM_FILE: 'vessel-summary/import',
    VESSEL_SUMMARY_SAVE_PREVIEW: 'vessel-summary/save-preview',
    VESSEL_SUMMARY_CHECK_PREVIEW: 'vessel-summary/check-preview',
    VESSEL_SUMMARY_HEADER: 'vessel-summary/header',
    VESSEL_SUMMARY_SAVE_DETAILS: 'vessel-summary/save-details',
    VESSEL_SUMMARY_EXPORT: 'vessel-summary/export',
    VESSEL_SUMMARY_EXPORT_BY_DATE: 'vessel-summary/export-by-date',
    VESSEL_SUMMARY_PUBLISH: 'vessel-summary/publish',
    VESSEL_SUMMARY: 'vessel-summary',
    VESSEL_SUMMARY_UPDATE_OPERATIONAL_LAYCAN: 'vessel-summary/update-operational-laycan',
    THEORETICAL_LOT_LINK_MOVEMENT_INSTRUCTION: 'theoretical-lots/link-movement-instruction',
    THEORETICAL_LOT_UNLINK_MOVEMENT_INSTRUCTION: 'theoretical-lots/unlink-movement-instruction',
    THEORETICAL_LOTS: 'theoretical-lots',
    THEORETICAL_LOTS_CREATE_MOVEMENT_INSTRUCTION: 'theoretical-lots/create-movement-instruction',
    THEORETICAL_LOTS_CHECK_MOVEMENT_INSTRUCTION: 'theoretical-lots/check-movement-instruction',
    THEORETICAL_LOTS_CHANGE_STATUS: 'theoretical-lots-change-voyage-status',
    THEORETICAL_LOTS_ALIGN_ACTUAL_INFO: 'theoretical-lots/align-actual-info-from-clearance',
    PLANNING_DEAL_NOTE : 'planning/deal-note',
    GET_PLANNING_DEAL_NOTE : 'planning/get-deal-note',
    EXPORT_PLANNING_DEAL_NOTE : 'planning/export-deal-note',
    UPLOAD_DEAL_NOTE: 'planning/upload-deal-note',
    GET_DEAL_NOTE_FROM_ARCHIFLOW: 'planning/get-deal-note-from-archiflow',
    DELETE_DEAL_NOTE_FROM_ARCHIFLOW: 'system/document-manager',
    DEAL_NOTE_DOCUMENT_MANAGER_DOWNLOAD: 'system/document-manager-download-document',
    THEORETICAL_LOTS_CHECK_MOVEMENT_INSTRUCTION_TO_BE_ASSOCIATED: 'theoretical-lots/check-movement-instruction-to-be-associated',
    GET_PLANNING_DEAL_NOTE_LOG: 'planning/get-deal-note-log',
    CLONE_PLANNING_DEAL_NOTE: 'planning/clona-deal-note',
    SPLIT_PLANNING_DEAL_NOTE: 'planning/split-deal-note',

    OPERATIVE_LEVELS_EXCEL_DOWNLOAD_TEMPLATE: 'tank-management/tank-operative-level-import-template-download',
    OPERATIVE_LEVELS_EXCEL_IMPORT_PARSE: 'tank-management/tank-operative-level-excel-import-parse',
    OPERATIVE_LEVELS_EXCEL_IMPORT: 'tank-management/tank-operative-level-import',

    STOCCHINO_PLAN_EXCEL: 'stocchino-plan-daily/export-stocchino-plan-excel',
    STOCCHINO_PLAN_AUTO: 'stocchino-plan-daily/auto',
    STOCCHINO_PLAN_STORAGE: 'stocchino-plan-daily/storage',
    STOCCHINO_PLAN_INVENTORY: 'stocchino-plan-daily/inventory-summary',
    STOCCHINO_PLAN_MIN_MAX_WS: 'stocchino-plan-daily/min-max-working-stock',

    STOCCHINO_PLAN_ELABORA_SVILUPPI_ECCEZIONI_SERBATOI: 'stocchino-plan-daily/elabora-sviluppi-eccezioni-stocchino',
    STOCCHINO_PLAN_CREATE: 'stocchino-plan-daily/create-stocchino-plan',
    STOCCHINO_PLAN_RECALCULATE: 'stocchino-plan-daily/ricalcola-stocchino-plan',
    STOCCHINO_PLAN_GET_HOLD_UP: 'stocchino-plan-daily/inventory-summary-hold-up-quantities',
    STOCCHINO_PLAN_GET_TANK_COMPOSITION: 'stocchino-plan-daily/auto-tank-composition',

    DAILY_PROFILES: 'daily-profiles',
    DAILY_PROFILES_INPUT_DATA: 'daily-profiles/input-data',
    DAILY_PROFILES_IMPORT_BMM_RANGE: 'daily-profiles/load-from-bim-bil-month-range',
    DAILY_PROFILES_IMPORT_BMG_RANGE: 'daily-profiles/load-from-bim-bil-day-range',
    DAILY_PROFILES_IMPORT_TP_RANGE: 'daily-profiles/load-from-tp-planned-range',
    DAILY_PROFILES_IMPORT_TP: 'daily-profiles/load-from-tp-planned',
    DAILY_PROFILES_IMPORT_STK_REAL: 'daily-profiles/load-tank-stk-detail-range',
    DAILY_PROFILES_IMPORT_MIN_MAX_WS: 'daily-profiles/load-min-max-ws-range',
    DAILY_PROFILES_CALCULATE: 'daily-profiles/calculate',
    DAILY_PROFILES_CREATE_MONTH: 'daily-profiles/create-month',
    DAILY_PROFILES_VOYAGE: 'daily-profiles/voyage',
    DAILY_PROFILES_MOVE_VOYAGE: 'daily-profiles/move-voyage',
    DAILY_PROFILES_TPP_PLANNED: 'daily-profiles/tp-planned',
    DAILY_PROFILES_TPP_PLANNED_SINGLE_PRODUCT: 'daily-profiles/tp-planned-single-product',
    DAILY_PROFILES_BMM: 'daily-profiles/bim-bil-month',
    DAILY_PROFILES_MIN_MAX_WS: 'daily-profiles/min-max-ws',
    DAILY_PROFILES_SUMMARY: 'daily-profiles/summary',
    DAILY_PROFILES_STATISTICS: 'daily-profiles/statistics',
    DAILY_PROFILES_REFRESH_SUMMARY: 'daily-profiles/refresh-summary',
    DAILY_PROFILES_CHART: 'daily-profiles/chart',
    DAILY_PROFILES_EXPORT_MIN_MAX_WS: 'daily-profiles/export-min-max-ws',
    DAILY_PROFILES_TRANSFER: 'daily-profiles/transfer',
    DAILY_PROFILES_EXCEL: 'daily-profiles/export-excel',
    DAILY_PROFILES_LIST: 'daily-profiles/list',
    DAILY_PROFILES_ALIGN_STK: 'daily-profiles/align-stk',
    DAILY_PROFILES_PRODUCTS_TREE_EXCEL: 'daily-profiles/products-tree-export-excel',
    DAILY_PROFILES_MASSIVE_MOVE_VOYAGES: 'daily-profiles/massive-move-voyage',
    TRUE_UP_PRICE_FORMULA: 'true-up/price-formula',
    TRUE_UP_PRICE_FORMULA_DETAILS: 'true-up/price-formula-detail',
    TRUE_UP_SETTLE: 'true-up/settle',
    TRUE_UP_SETTLE_DAILY_PRICE: 'true-up/settle-daily-price',
    TRUE_UP_PROVISIONAL_INVOICE: 'true-up/provisional-invoice',
    TRUE_UP_PROVISIONAL_INVOICE_IMPORT: 'true-up/provisional-invoice-import',
    TRUE_UP_PROVISIONAL_INVOICE_EXPORT_EXCEL: 'true-up/provisional-invoice-export-excel',
    TRUE_UP_PRODUCTS_WEIGHTED_AVERAGE_VALUE: 'true-up/products-weight-average-value',
    TRUE_UP_PRODUCTS_WEIGHTED_AVERAGE_VALUE_EXPORT: 'true-up/products-weight-average-value-export-excel',
    TRUE_UP_PRODUCTS_WTD_DETAIL: 'true-up/products-wtd-detail',

    TRUE_UP_INVOICE_PRICES: 'true-up/invoice-prices-get-prices',
    TRUE_UP_INVOICE_PRICE_EXPORT_EXCEL: 'true-up/invoice-prices-export-excel',

    TRUE_UP_FEEDSTOCKS_WEIGHTED_AVERAGE_VALUE: 'true-up/feedstock-weighted-average-value',
    TRUE_UP_FEEDSTOCKS_WEIGHTED_AVERAGE_VALUE_GET_TANKS: 'true-up/feedstock-weighted-average-value-feedstock-tanks',
    TRUE_UP_FEEDSTOCKS_WTD_DETAIL: 'true-up/feedstock-wtd-detail',
    TRUE_UP_FEEDSTOCKS_WEIGHTED_AVERAGE_VALUE_IMPORT: 'true-up/feedstock-weighted-average-value-import',
    TRUE_UP_FEEDSTOCKS_WEIGHTED_AVERAGE_VALUE_EXPORT_EXCEL: 'true-up/feedstock-weighted-average-value-export-excel',

    TRUE_UP_PRICED_QUANTITIES_BALANCE_GRID: 'true-up/priced-quantity-balance-get-data-grid',
    TRUE_UP_PRICED_QUANTITIES_BALANCE_CALCULATE: 'true-up/priced-quantity-balance-calculate',
    TRUE_UP_PRICED_QUANTITIES_BALANCE_EXPORT: 'true-up/priced-quantity-balance-export-excel',
    TRUE_UP_PRICED_QUANTITIES_BALANCE: 'true-up/priced-quantity-balance',

    TRUE_UP_FINAL_INVOICE_GET_TOTAL_PRICED_QUANTITY: 'true-up/final-invoice-get-total-priced-quantities',
    TRUE_UP_FINAL_INVOICE_GET_DELTA_PRICE: 'true-up/final-invoice-get-total-delta-prices',
    TRUE_UP_FINAL_INVOICE_GET_TOTAL_FINAL_INVOICE: 'true-up/final-invoice-get-total-final-invoices',
    TRUE_UP_FINAL_INVOICE_GET_GRAND_TOTAL: 'true-up/final-invoice-get-grand-total',
    TRUE_UP_FINAL_INVOICE_CALCULATE: 'true-up/final-invoice-calculate',
    TRUE_UP_FINAL_INVOICE_EXPORT_EXCEL: 'true-up/final-invoice-export-excel',
    TRUE_UP_EXPORT_EXCEL_COMPLETE: 'true-up/export-complete-excel',

    TRUE_UP_FAMILY_POOL_CONFIGURATION_CLONE: 'true-up/family-pool-configuration/clone',
    TRUE_UP_SETTLE_DAILY_PRICE_EXPORT_EXCEL: 'true-up/settle-daily-price-export-excel',
    TRUE_UP_SETTLE_IMPORT: 'true-up/settle-import',
    TRUE_UP_PRODUCTS_WEIGHT_AVERAGE_VALUE_IMPORT: 'true-up/products-weight-average-value-import',
    TRUE_UP_PREMIUM_OR_DISCOUNT_EXPORT: 'true-up/premium-or-discount-excel',

    DEAL_NOTE_PRICE_WINDOW: 'planning/deal-note-price-window',
    DEAL_NOTE_PRICE_WINDOW_TYPE: 'masterdata/price-window-type',
    DEAL_NOTE_PRICE_WINDOW_DATE_TYPE: 'masterdata/price-window-date-type',

    GET_PLANNING_BOOK_OUT: 'planning/get-book-out',
    EXPORT_PLANNING_BOOK_OUT : 'planning/export-book-out',
    PLANNING_BOOK_OUT_DETAIL: 'planning/book-out-detail',
    PLANNING_BOOK_OUT: 'planning/book-out',
    PLANNING_BOOK_OUT_CALCULATE: 'planning/book-out-calculate',

    TRUE_UP_STOCK_ADJUSTMENT: 'planning-stock-adjustment',
    TRUE_UP_STOCK_ADJUSTMENT_CALCULATE: 'planning-stock-adjustment-calculate-volumetric-data',
    TRUE_UP_STOCK_ADJUSTMENT_IMPORT: 'planning/stock-adjustment-import-adjustments',
    TRUE_UP_STOCK_ADJUSTMENT_DEADSTOCKS: 'planning/stock-adjustment-get-deadstock',
    TRUE_UP_STOCK_ADJUSTMENT_SAVE_DEADSTOCKS: 'planning/stock-adjustment-insert-deadstock',

    ROLLING_INVENTORY: 'rolling-inventory-header',
    ROLLING_INVENTORY_COMBO: 'rolling-inventory-header/combo',
    ROLLING_INVENTORY_CALCULATE: 'rolling-inventory-header/calculate-version',
    ROLLING_INVENTORY_UPDATE_OFFTAKE: 'rolling-inventory-offtake',
    ROLLING_INVENTORY_UPDATE_CLOSINGOPENING: 'rolling-inventory-closing-opening',
    ROLLING_INVENTORY_PRODUCTION_CONSUMPTION: 'rolling-inventory-production-consumption',
    ROLLING_INVENTORY_IMPORT_MOVEMENTS_BY_HEADER: 'rolling-inventory-import-movement/by-header',
    ROLLING_INVENTORY_IMPORT_MOVEMENTS: 'rolling-inventory-import-movement',
    ROLLING_INVENTORY_EXPORT_EXCEL: 'rolling-inventory-header/export-excel',
    ROLLING_INVENTORY_HEADER_UPDATE_WEEKLY: 'rolling-inventory-header/update-weekly',
    ROLLING_INVENTORY_CHARTS: 'rolling-inventory-header/charts',
    ROLLING_INVENTORY_UPDATE_TARGET: 'rolling-inventory-header/update-target',

    TRUE_UP_FINAL_INVOICE_TOLLING: 'true-up/final-invoice-priced-quantity-balance-tolling',
    TRUE_UP_FINAL_PRICE_TOLLING: 'true-up/get-true-up-final-price',
    TRUE_UP_FINAL_INVOICE_TRUE_UP: 'true-up/final-invoice-get-final-invoices-trueup',
    TRUE_UP_TOLLING_PRICE: 'true-up/get-tolling-final-prices',
    TRUE_UP_TOLLING_INVOICE_AMOUNT: 'true-up/final-invoice-get-final-invoices-tolling',
    TRUE_UP_TOLLING_DELTA_AMOUNT: 'true-up/get-delta-final-prices',

    TRUE_UP_TOLLING_PRICE_HEADER: 'true-up/tolling-price-header',
    TRUE_UP_TOLLING_PRICE_HEADER_BY_MONTH: 'true-up/tolling-prices-by-month',
    TRUE_UP_TOLLING_PRICE_COMBO: 'true-up/tolling-price-header-combo',
    TRUE_UP_TOLLING_PRICE_DETAILS: 'true-up/tolling-price-details',
    TRUE_UP_TOLLING_PRICE_EXPORT_EXCEL: 'true-up/tolling-price-header-export',
    TRUE_UP_TOLLING_PRICE_WEIGHTED_AVG_TOLLING_PRICE: 'true-up/tolling-price-header-weighted-avg-tolling-price',
    TRUE_UP_CRUDE_WEIGHTED_AVERAGE_VALUE_GET_TANKS: 'true-up/feedstock-weighted-average-value-crude-tanks',
    TRUE_UP_CRUDE_WTD_DETAIL: 'true-up/update-crude-wtd-detail',
    TRUE_UP_CRUDE_TOLLING_AVERAGE_VALUE_EXPORT_EXCEL: 'true-up/export-excel-crude-tolling',
    TRUE_UP_TOLLING_PRICE_HEADER_CLONE: 'true-up/tolling-price-header-clone',
    TRUE_UP_PROVISIONAL_INVOICE_GET_DATA_IMPORT_FROM_EXCEL: 'true-up/provisional-invoice-get-weekly-data-from-excel',
    TRUE_UP_PROVISIONAL_INVOICE_IMPORT_FROM_EXCEL: 'true-up/provisional-invoice-import-from-excel'
}

import genericService from '../genericService';

export default {

    async importVesselSummaryFromFile(body, callback){
        await genericService.post(urls.VESSEL_SUMMARY_IMPORT_FROM_FILE, body).then(callback);
    },
    async saveVesselSummaryPreview(body, callback){
        await genericService.post(urls.VESSEL_SUMMARY_SAVE_PREVIEW, body).then(callback);
    },
    async checkVesselSummaryPreview(body, callback){
        await genericService.get(urls.VESSEL_SUMMARY_SAVE_PREVIEW, body).then(callback);
    },
    async getVesselSummaryHeader(body, callback){
        await genericService.getItem(urls.VESSEL_SUMMARY_HEADER, body).then(callback);
    },
    async getVesselSummary(body, callback){
        await genericService.get(urls.VESSEL_SUMMARY, body).then(callback);
    },
    async saveVesselSummaryDetails(body, callback){
        await genericService.putNoId(urls.VESSEL_SUMMARY_SAVE_DETAILS, body).then(callback);
    },
    async linkMovementInstruction(body, callback){
        await genericService.post(urls.THEORETICAL_LOT_LINK_MOVEMENT_INSTRUCTION, body).then(callback);
    },
    async unlinkMovementInstruction(id, callback){
        await genericService.put(urls.THEORETICAL_LOT_UNLINK_MOVEMENT_INSTRUCTION, id).then(callback);
    },
    async exportVesselSummary(body, callback){
        await genericService.dowloadFile(urls.VESSEL_SUMMARY_EXPORT, body).then(callback);
    },
    async exportVesselSummaryByDate(body, callback){
        await genericService.dowloadFile(urls.VESSEL_SUMMARY_EXPORT_BY_DATE, body).then(callback);
    },
    async publishVesselSummary(body, callback){
        let url = `${urls.VESSEL_SUMMARY_PUBLISH}?startDate=${body.startDate}&week=${body.week}&year=${body.year}`;
        await genericService.post(url, body).then(callback);
    },
    async getTheoreticalLots(body, callback){
        await genericService.get(urls.THEORETICAL_LOTS, body).then(callback);
    }, 
    async getTheoreticalLot(body, callback){
        await genericService.getItem(urls.THEORETICAL_LOTS, body).then(callback);
    },
    async createMovementInstruction(body, callback){
        await genericService.post(urls.THEORETICAL_LOTS_CREATE_MOVEMENT_INSTRUCTION, body).then(callback);
    },
    async checkMovementInstruction(id, callback){
        await genericService.getItem(urls.THEORETICAL_LOTS_CHECK_MOVEMENT_INSTRUCTION, id).then(callback);
    },
    async checkMovementInstructionToBeAssociated(id, callback){
        await genericService.getItem(urls.THEORETICAL_LOTS_CHECK_MOVEMENT_INSTRUCTION_TO_BE_ASSOCIATED, id).then(callback);
    },
    async getPlanningDealNote (body, callback){
        await genericService.get(urls.GET_PLANNING_DEAL_NOTE, body).then(callback);
    },
    async createPlanningDealNote (body, callback){
        await genericService.post(urls.PLANNING_DEAL_NOTE, body).then(callback);
    },
    async updatePlanningDealNote (body, callback){
        await genericService.put(urls.PLANNING_DEAL_NOTE, body).then(callback);
    },
    async exportPlanningDealNote (body, callback){
        await genericService.dowloadFile(urls.EXPORT_PLANNING_DEAL_NOTE, body).then(callback);
    },
    async uploadPlanningDealNote (body, callback){
        await genericService.post(urls.UPLOAD_DEAL_NOTE, body).then(callback);
    },
    async getDealNoteFromArchiflow (body, callback){
        await genericService.getItem(urls.GET_DEAL_NOTE_FROM_ARCHIFLOW, body).then(callback);
    },
    async getDealNoteLog (body, callback){
        await genericService.getItem(urls.GET_PLANNING_DEAL_NOTE_LOG, body).then(callback);
    },
    async cloneDealNote (body, callback){
        await genericService.post(urls.CLONE_PLANNING_DEAL_NOTE, body).then(callback);
    },
    async splitDealNote (body, callback){
        await genericService.post(urls.SPLIT_PLANNING_DEAL_NOTE, body).then(callback);
    },
    async deleteDealNoteFromArchiflow (body, callback){
        await genericService.deleteBody(urls.DELETE_DEAL_NOTE_FROM_ARCHIFLOW, body).then(callback);
    },
    async downloadOperativeLevelsExcelTemplate(body, callback){
        await genericService.dowloadFile(urls.OPERATIVE_LEVELS_EXCEL_DOWNLOAD_TEMPLATE, body).then(callback);
    },
    async downloadDocumentDealNote(body, callback){
        await genericService.dowloadFile(urls.DEAL_NOTE_DOCUMENT_MANAGER_DOWNLOAD, body).then(callback);
    },
    async importOperativeLevelsExcelParse(body, callback){
        await genericService.uploadFile(urls.OPERATIVE_LEVELS_EXCEL_IMPORT_PARSE, body).then(callback);
    },
    async importOperativeLevelsExcel(body, callback){
        await genericService.post(urls.OPERATIVE_LEVELS_EXCEL_IMPORT, body).then(callback);
    },
    async loadStocchinoPlanAuto(body, callback){
        await genericService.get(urls.STOCCHINO_PLAN_AUTO, body).then(callback);
    },
    async updateStocchinoPlanAuto(body, callback){
        await genericService.post(urls.STOCCHINO_PLAN_AUTO, body).then(callback);
    },
    async loadStocchinoPlanInventory(body, callback){
        await genericService.get(urls.STOCCHINO_PLAN_INVENTORY, body).then(callback);
    },
    async updateStocchinoPlanInventory(body, callback){
        await genericService.post(urls.STOCCHINO_PLAN_INVENTORY, body).then(callback);
    },
    async loadStocchinoPlanStorage(body, callback){
        await genericService.get(urls.STOCCHINO_PLAN_STORAGE, body).then(callback);
    },
    async loadStocchinoPlanMinMaxWS(body, callback){
        await genericService.get(urls.STOCCHINO_PLAN_MIN_MAX_WS, body).then(callback);
    },
    async updateStocchinoPlanMinMaxWS(body, callback){
        await genericService.post(urls.STOCCHINO_PLAN_MIN_MAX_WS, body).then(callback);
    },
    async processTankExceptionsStocchinoPlan(body, callback){
        await genericService.post(urls.STOCCHINO_PLAN_ELABORA_SVILUPPI_ECCEZIONI_SERBATOI + '?dataStocchino=' + body, {}).then(callback);
    },
    async createStocchinoPlan(body, callback){
        await genericService.post(urls.STOCCHINO_PLAN_CREATE + '?dataStocchino=' + body, {}).then(callback);
    },
    async recalculateStocchinoPlan(body, callback){
        await genericService.post(urls.STOCCHINO_PLAN_RECALCULATE + '?dataStocchino=' + body, {}).then(callback);
    },
    async getStocchinoPlanHoldUpQuantities(body, callback){
        await genericService.get(urls.STOCCHINO_PLAN_GET_HOLD_UP, body).then(callback);
    },
    async exportStocchinoPlan(body, callback){
        await genericService.dowloadFile(urls.STOCCHINO_PLAN_EXCEL, body).then(callback);
    },
    async getStocchinoPlanTankComposition(body, callback){
        await genericService.get(urls.STOCCHINO_PLAN_GET_TANK_COMPOSITION, body).then(callback);
    },
    async getDailyProfiles(body, callback){
        await genericService.get(urls.DAILY_PROFILES, body).then(callback);
    },
    async updateDailyProfileRow(body, callback){
        await genericService.post(urls.DAILY_PROFILES, body).then(callback);
    },
    async getDailyProfilesInputData(body, callback){
        await genericService.get(urls.DAILY_PROFILES_INPUT_DATA, body).then(callback);
    },
    async loadBMMRange(body, callback){
        let url = `${urls.DAILY_PROFILES_IMPORT_BMM_RANGE}?startDate=${body.startDate}&endDate=${body.endDate}`;
        await genericService.post(url, {}).then(callback);
    },
    async loadBMGRange(body, callback){
        let url = `${urls.DAILY_PROFILES_IMPORT_BMG_RANGE}?startDate=${body.startDate}&endDate=${body.endDate}`;
        await genericService.post(url, {}).then(callback);
    },
    async loadTpRange(body, callback){
        let url = `${urls.DAILY_PROFILES_IMPORT_TP_RANGE}?startDate=${body.startDate}&endDate=${body.endDate}`;
        await genericService.post(url, {}).then(callback);
    },
    async loadTp(body, callback){
        let url = `${urls.DAILY_PROFILES_IMPORT_TP}?refDate=${body.refDate}&processingProductionHeaderId=${body.processingProductionHeaderId}`;
        await genericService.post(url, {}).then(callback);
    },
    async loadStkRealRange(body, callback){
        let url = `${urls.DAILY_PROFILES_IMPORT_STK_REAL}?startDate=${body.startDate}&endDate=${body.endDate}`;
        await genericService.post(url, {}).then(callback);
    },
    async loadMinMaxWsRange(body, callback){
        let url = `${urls.DAILY_PROFILES_IMPORT_MIN_MAX_WS}?startDate=${body.startDate}&endDate=${body.endDate}`;
        await genericService.post(url, {}).then(callback);
    },
    async calculateDailyProfiles(body, callback){
        let url = `${urls.DAILY_PROFILES_CALCULATE}?startDate=${body.startDate}&familyName=${body.familyName}`;
        await genericService.post(url, {}).then(callback);
    },
    async dailyProfilesCreateMonth(body, callback){
        let url = `${urls.DAILY_PROFILES_CREATE_MONTH}?month=${body.month}&familyName=${body.familyName}`;
        await genericService.post(url, {}).then(callback);
    },
    async getDailyProfilesVoyages(body, callback){
        await genericService.get(urls.DAILY_PROFILES_VOYAGE, body).then(callback);
    },
    async createDailyProfilesVoyages(body, callback){
        await genericService.post(urls.DAILY_PROFILES_VOYAGE, body).then(callback);
    },
    async updateDailyProfilesVoyage(body, callback){
        await genericService.put(urls.DAILY_PROFILES_VOYAGE, body).then(callback);
    },
    async deleteDailyProfilesVoyage(id, callback){
        await genericService.delete(urls.DAILY_PROFILES_VOYAGE, id).then(callback);
    },
    async moveDailyProfilesVoyages(body, callback){
        await genericService.put(urls.DAILY_PROFILES_MOVE_VOYAGE, body).then(callback);
    },
    async insertDailyProfilesBMM(body, callback){
        await genericService.post(urls.DAILY_PROFILES_BMM, body).then(callback);
    },
    async updateDailyProfilesBMM(body, callback){
        await genericService.put(urls.DAILY_PROFILES_BMM, body).then(callback);
    },
    async deleteDailyProfilesBMM(id, callback){
        await genericService.delete(urls.DAILY_PROFILES_BMM, id).then(callback);
    },
    async insertDailyProfilesTPPlanned(body, callback){
        await genericService.post(urls.DAILY_PROFILES_TPP_PLANNED, body).then(callback);
    },
    async updateDailyProfilesTPPlanned(body, callback){
        await genericService.put(urls.DAILY_PROFILES_TPP_PLANNED, body).then(callback);
    },
    async deleteDailyProfilesTPPlanned(id, callback){
        await genericService.delete(urls.DAILY_PROFILES_TPP_PLANNED, id).then(callback);
    },
    async insertDailyProfilesMinMaxWs(body, callback){
        await genericService.post(urls.DAILY_PROFILES_MIN_MAX_WS, body).then(callback);
    },
    async updateDailyProfilesMinMaxWs(body, callback){
        await genericService.put(urls.DAILY_PROFILES_MIN_MAX_WS, body).then(callback);
    },
    async deleteDailyProfilesMinMaxWs(id, callback){
        await genericService.delete(urls.DAILY_PROFILES_MIN_MAX_WS, id).then(callback);
    },
    async getDailyProfilesSummary(body, callback){
        await genericService.get(urls.DAILY_PROFILES_SUMMARY, body).then(callback);
    },
    async getDailyProfilesStatistics(body, callback){
        await genericService.get(urls.DAILY_PROFILES_STATISTICS, body).then(callback);
    },
    async updateDailyProfilesSummary(body, callback){
        await genericService.put(urls.DAILY_PROFILES_SUMMARY, body).then(callback);
    },
    async insertDailyProfilesSummary(body, callback){
        await genericService.post(urls.DAILY_PROFILES_SUMMARY, body).then(callback);
    },
    async refreshDailyProfilesSummary(body, callback){
        let url = `${urls.DAILY_PROFILES_REFRESH_SUMMARY}?referenceDate=${body.referenceDate}&familyId=${body.familyId}`;
        await genericService.post(url, body).then(callback);
    },
    async getDailyProfilesChart(body, callback){
        await genericService.get(urls.DAILY_PROFILES_CHART, body).then(callback);
    },
    async exportMinMaxWsDp(body, callback){
        await genericService.post(urls.DAILY_PROFILES_EXPORT_MIN_MAX_WS, body).then(callback);
    },
    async updateDailyProfilesFamilyTransfer(body, callback){
        await genericService.put(urls.DAILY_PROFILES_TRANSFER, body).then(callback);
    },
    async insertDailyProfilesFamilyTransfer(body, callback){
        await genericService.post(urls.DAILY_PROFILES_TRANSFER, body).then(callback);
    },
    async exportDailyProfilesAsExcel(body, callback){
        await genericService.dowloadFile(urls.DAILY_PROFILES_EXCEL, body).then(callback);
    },
    async changeTheoreticalLotStatus(body, callback){
        await genericService.put(urls.THEORETICAL_LOTS_CHANGE_STATUS, body).then(callback);
    },
    async updateDailyProfileList(body, callback){
        await genericService.post(urls.DAILY_PROFILES_LIST, body).then(callback);
    },
    async dailyProfilesAlignStk(body, callback){
        let url = `${urls.DAILY_PROFILES_ALIGN_STK}?startDate=${body.startDate}&endDate=${body.endDate}&familyId=${body.familyId}`;
        await genericService.post(url, body).then(callback);
    },
    async getPriceFormula(body, callback){
        await genericService.get(urls.TRUE_UP_PRICE_FORMULA, body).then(callback);
    },
    async updatePriceFormula(body, callback){
        await genericService.put(urls.TRUE_UP_PRICE_FORMULA, body).then(callback);
    },
    async addPriceFormula(body, callback){
        await genericService.post(urls.TRUE_UP_PRICE_FORMULA, body).then(callback);
    },
    async getPriceFormulaDetails(body, callback){
        await genericService.get(urls.TRUE_UP_PRICE_FORMULA_DETAILS, body).then(callback);
    },
    async updatePriceFormulaDetails(body, callback){
        await genericService.put(urls.TRUE_UP_PRICE_FORMULA_DETAILS, body).then(callback);
    },
    async addPriceFormulaDetails(body, callback){
        await genericService.post(urls.TRUE_UP_PRICE_FORMULA_DETAILS, body).then(callback);
    },
    async deletePriceFormulaDetails(id, callback){
        await genericService.delete(urls.TRUE_UP_PRICE_FORMULA_DETAILS, id).then(callback);
    },
    async getSettle(body, callback){
        await genericService.get(urls.TRUE_UP_SETTLE, body).then(callback);
    },
    async updateSettle(body, callback){
        await genericService.put(urls.TRUE_UP_SETTLE, body).then(callback);
    },
    async addSettle(body, callback){
        await genericService.post(urls.TRUE_UP_SETTLE, body).then(callback);
    },
    async getSettleDailyPrice(body, callback){
        await genericService.get(urls.TRUE_UP_SETTLE_DAILY_PRICE, body).then(callback);
    },
    async updateSettleDailyPrice(body, callback){
        await genericService.put(urls.TRUE_UP_SETTLE_DAILY_PRICE, body).then(callback);
    },
    async addSettleDailyPrice(body, callback){
        await genericService.post(urls.TRUE_UP_SETTLE_DAILY_PRICE, body).then(callback);
    },
    async deleteSettleDailyPrice(id, callback){
        await genericService.delete(urls.TRUE_UP_SETTLE_DAILY_PRICE, id).then(callback);
    },
    async updateProvisionalInvoice(body, callback){
        await genericService.put(urls.TRUE_UP_PROVISIONAL_INVOICE, body).then(callback);
    },
    async addProvisionalInvoice(body, callback){
        await genericService.post(urls.TRUE_UP_PROVISIONAL_INVOICE, body).then(callback);
    },
    async importProvisionalInvoice(body, callback){
        await genericService.post(urls.TRUE_UP_PROVISIONAL_INVOICE_IMPORT, body).then(callback);
    },
    async getProductWeightedAverageValue(body, callback){
        await genericService.get(urls.TRUE_UP_PRODUCTS_WEIGHTED_AVERAGE_VALUE, body).then(callback);
    },
    async updateProductWeightedAverageDetailValue(body, callback){
        await genericService.put(urls.TRUE_UP_PRODUCTS_WTD_DETAIL, body).then(callback);
    },
    async getFeedstocksWeightedAverageValue(body, callback){
        await genericService.get(urls.TRUE_UP_FEEDSTOCKS_WEIGHTED_AVERAGE_VALUE, body).then(callback);
    },
    async getFeedstocksWeightedAverageValueTanks(body, callback){
        await genericService.get(urls.TRUE_UP_FEEDSTOCKS_WEIGHTED_AVERAGE_VALUE_GET_TANKS, body).then(callback);
    },
    async exportFeedstocksWeightedAverageValue(body, callback){
        await genericService.dowloadFile(urls.TRUE_UP_FEEDSTOCKS_WEIGHTED_AVERAGE_VALUE_EXPORT_EXCEL, body).then(callback);
    },
    async updateFeedstocksWeightedAverageDetailValue(body, callback){
        await genericService.put(urls.TRUE_UP_FEEDSTOCKS_WTD_DETAIL, body).then(callback);
    },
    async importFeedstocksWeightedAverageDetailValue(body, callback){
        await genericService.post(urls.TRUE_UP_FEEDSTOCKS_WEIGHTED_AVERAGE_VALUE_IMPORT, body).then(callback);
    },
    async importProductsWeightedAverageDetailValue(body, callback){
        await genericService.post(urls.TRUE_UP_PRODUCTS_WEIGHT_AVERAGE_VALUE_IMPORT, body).then(callback);
    },
    async getInvoicePrices(body, callback){
        await genericService.get(urls.TRUE_UP_INVOICE_PRICES, body).then(callback);
    },
    async getPricedQuantitiesBalanceGrid(body, callback){
        await genericService.get(urls.TRUE_UP_PRICED_QUANTITIES_BALANCE_GRID, body).then(callback);
    },
    async calculatePricedQuantitiesBalance(body, callback){
        await genericService.post(urls.TRUE_UP_PRICED_QUANTITIES_BALANCE_CALCULATE, body).then(callback);
    },
    async updatePricedQuantitiesBalanceGrid(body, callback){
        await genericService.put(urls.TRUE_UP_PRICED_QUANTITIES_BALANCE, body).then(callback);
    },
    async getFinalInvoiceGetTotalPricedQuantity(body, callback){
        await genericService.get(urls.TRUE_UP_FINAL_INVOICE_GET_TOTAL_PRICED_QUANTITY, body).then(callback);
    },
    async getFinalInvoiceGetDeltaPrice(body, callback){
        await genericService.get(urls.TRUE_UP_FINAL_INVOICE_GET_DELTA_PRICE, body).then(callback);
    },
    async getFinalInvoiceGetTotalFinalInvoice(body, callback){
        await genericService.get(urls.TRUE_UP_FINAL_INVOICE_GET_TOTAL_FINAL_INVOICE, body).then(callback);
    },
    async getFinalInvoiceGetGrandTotal(body, callback){
        await genericService.get(urls.TRUE_UP_FINAL_INVOICE_GET_GRAND_TOTAL, body).then(callback);
    },
    async calculateFinalInvoice(body, callback){
        await genericService.post(urls.TRUE_UP_FINAL_INVOICE_CALCULATE, body).then(callback);
    },
    async exportInvoicePrices (body, callback){
        await genericService.dowloadFile(urls.TRUE_UP_INVOICE_PRICE_EXPORT_EXCEL, body).then(callback);
    },
    async cloneFamilyPoolConfiguration(body, callback){
        await genericService.post(urls.TRUE_UP_FAMILY_POOL_CONFIGURATION_CLONE, body).then(callback);
    },
    async exportTrueUpProvisionalInvoice(body, callback){
        await genericService.dowloadFile(urls.TRUE_UP_PROVISIONAL_INVOICE_EXPORT_EXCEL, body).then(callback);
    },
    async exportSettleDailyPrice(body, callback){
        await genericService.dowloadFile(urls.TRUE_UP_SETTLE_DAILY_PRICE_EXPORT_EXCEL, body).then(callback);
    },
    async importSettle(body, callback){
        await genericService.post(urls.TRUE_UP_SETTLE_IMPORT, body).then(callback);
    },
    async exportPricedQuantitiesBalance(body, callback){
        await genericService.dowloadFile(urls.TRUE_UP_PRICED_QUANTITIES_BALANCE_EXPORT, body).then(callback);
    },
    async exportExcelFinalInvoice(body, callback){
        await genericService.dowloadFile(urls.TRUE_UP_FINAL_INVOICE_EXPORT_EXCEL, body).then(callback);
    },
    async exportProductWeightedAverageValue(body, callback){
        await genericService.dowloadFile(urls.TRUE_UP_PRODUCTS_WEIGHTED_AVERAGE_VALUE_EXPORT, body).then(callback);
    },
    async getAlignActualInfo(id, callback){
        await genericService.getItem(urls.THEORETICAL_LOTS_ALIGN_ACTUAL_INFO, id).then(callback);
    },
    async exportPremiumOrDiscountExcel(body, callback){
        await genericService.dowloadFile(urls.TRUE_UP_PREMIUM_OR_DISCOUNT_EXPORT, body).then(callback);
    },
    async updateDailyProfilesTPPlannedSingleProduct(body, callback){
        await genericService.put(urls.DAILY_PROFILES_TPP_PLANNED_SINGLE_PRODUCT, body).then(callback);
    },
    async deleteDailyProfilesTPPlannedSingleProduct(id, callback){
        await genericService.delete(urls.DAILY_PROFILES_TPP_PLANNED_SINGLE_PRODUCT, id).then(callback);
    },
    async exportDailyProfilesProductTreeAsExcel(body, callback){
        await genericService.dowloadFile(urls.DAILY_PROFILES_PRODUCTS_TREE_EXCEL, body).then(callback);
    },
    async massiveMoveVoyages(body, callback){
        await genericService.post(urls.DAILY_PROFILES_MASSIVE_MOVE_VOYAGES, body).then(callback);
    },
    async exportTrueUpCompleteExcel(body, callback){
        await genericService.dowloadFile(urls.TRUE_UP_EXPORT_EXCEL_COMPLETE, body).then(callback);
    },
    async updateDealNotePriceWindow(body, callback){
        await genericService.put(urls.DEAL_NOTE_PRICE_WINDOW, body).then(callback);
    },
    async addDealNotePriceWindow(body, callback){
        await genericService.post(urls.DEAL_NOTE_PRICE_WINDOW, body).then(callback);
    },
    async getDealNotePriceWindowType(body, callback){
        await genericService.get(urls.DEAL_NOTE_PRICE_WINDOW_TYPE, body).then(callback);
    },
    async getDealNotePriceWindowDateType(body, callback){
        await genericService.get(urls.DEAL_NOTE_PRICE_WINDOW_DATE_TYPE, body).then(callback);
    },
    async updateOperationalLaycan(body, callback){
        await genericService.put(urls.VESSEL_SUMMARY_UPDATE_OPERATIONAL_LAYCAN, body).then(callback);
    },
    async getPlanningBookOut(body, callback){
        await genericService.get(urls.GET_PLANNING_BOOK_OUT, body).then(callback);
    },
    async exportPlanningBookOut(body, callback){
        await genericService.dowloadFile(urls.EXPORT_PLANNING_BOOK_OUT, body).then(callback);
    },
    async updatePlanningBookOutDetail(body, callback){
        await genericService.put(urls.PLANNING_BOOK_OUT_DETAIL, body).then(callback);
    },
    async calculatePlanningBookOut(body, callback){
        await genericService.post(urls.PLANNING_BOOK_OUT_CALCULATE, body).then(callback);
    },
    async addPlanningStockAdjustment(body, callback){
        await genericService.post(urls.TRUE_UP_STOCK_ADJUSTMENT, body).then(callback);
    },
    async updatePlanningStockAdjustment(body, callback){
        await genericService.put(urls.TRUE_UP_STOCK_ADJUSTMENT, body).then(callback);
    },
    async calculatePlanningStockAdjustment(body, callback){
        await genericService.post(urls.TRUE_UP_STOCK_ADJUSTMENT_CALCULATE, body).then(callback);
    },
    async importPlanningStockAdjustment(body, callback){
        await genericService.post(urls.TRUE_UP_STOCK_ADJUSTMENT_IMPORT, body).then(callback);
    },
    async getAllDeadstocks(body, callback){
        await genericService.get(urls.TRUE_UP_STOCK_ADJUSTMENT_DEADSTOCKS, body).then(callback);
    },
    async insertMassiveDeadstocks(body, callback){
        await genericService.post(urls.TRUE_UP_STOCK_ADJUSTMENT_SAVE_DEADSTOCKS, body).then(callback);
	},
    async getRollingInventory(id, callback){
        await genericService.getItem(urls.ROLLING_INVENTORY, id).then(callback);
	},
    async deleteRollingInventory(id, callback){
        await genericService.delete(urls.ROLLING_INVENTORY, id).then(callback);
	},
    async calculateRollingInventory(body, callback){
        await genericService.post(urls.ROLLING_INVENTORY_CALCULATE, body).then(callback);
	},
    async getRollingInventoryCombo(body, callback){
        await genericService.get(urls.ROLLING_INVENTORY_COMBO, body).then(callback);
    },
    async updateRollingInventoryClosingOpening(body, callback){
        await genericService.put(urls.ROLLING_INVENTORY_UPDATE_CLOSINGOPENING, body).then(callback);
    },
    async updateRollingInventoryOfftake(body, callback){
        await genericService.put(urls.ROLLING_INVENTORY_UPDATE_OFFTAKE, body).then(callback);
    },
    async deleteRollingInventoryOfftake(id, callback){
        await genericService.delete(urls.ROLLING_INVENTORY_UPDATE_OFFTAKE, id).then(callback);
	},
    async deleteRollingInventoryProductionConsumption(id, callback){
        await genericService.delete(urls.ROLLING_INVENTORY_PRODUCTION_CONSUMPTION, id).then(callback);
    },
    async updateRollingInventoryProductionConsumption(body, callback){
        await genericService.put(urls.ROLLING_INVENTORY_PRODUCTION_CONSUMPTION, body).then(callback);
    },
    async getRollingInventoryImportMovements(id, callback){
        await genericService.getItem(urls.ROLLING_INVENTORY_IMPORT_MOVEMENTS_BY_HEADER, id).then(callback);
	},
    async updateRollingInventoryImportMovements(body, callback){
        await genericService.put(urls.ROLLING_INVENTORY_IMPORT_MOVEMENTS, body).then(callback);
	},
    async deleteRollingInventoryImportMovements(id, callback){
        await genericService.delete(urls.ROLLING_INVENTORY_IMPORT_MOVEMENTS, id).then(callback);
	},
    async exportRollingInventory(id, callback){
        await genericService.dowloadFilePathVariable(urls.ROLLING_INVENTORY_EXPORT_EXCEL, id).then(callback);
    },
    async rollingInventoryChangeWeeklyManual(body, callback){
        await genericService.post(urls.ROLLING_INVENTORY_HEADER_UPDATE_WEEKLY, body).then(callback);
    },
    async getRollingInventoryCharts(id, callback){
        await genericService.getItem(urls.ROLLING_INVENTORY_CHARTS, id).then(callback);
	},
     async updateRollingInventoryTarget(body, callback){
        await genericService.put(urls.ROLLING_INVENTORY_UPDATE_TARGET, body).then(callback);
	},
    async getTrueUpFinalInvoiceTolling(body, callback){
        await genericService.get(urls.TRUE_UP_FINAL_INVOICE_TOLLING, body).then(callback);
    },
    async getTrueUpFinalPriceTolling(body, callback){
        await genericService.get(urls.TRUE_UP_FINAL_PRICE_TOLLING, body).then(callback);
    },
    async getTrueUpFinalInvoiceAmount(body, callback){
        await genericService.get(urls.TRUE_UP_FINAL_INVOICE_TRUE_UP, body).then(callback);
    },
    async getTrueUpTollingPrice(body, callback){
        await genericService.get(urls.TRUE_UP_TOLLING_PRICE, body).then(callback);
    },
    async getTrueUpTollingInvoiceAmount(body, callback){
        await genericService.get(urls.TRUE_UP_TOLLING_INVOICE_AMOUNT, body).then(callback);
    },
    async getTrueUpTollingDeltaAmount(body, callback){
        await genericService.get(urls.TRUE_UP_TOLLING_DELTA_AMOUNT, body).then(callback);
    },
    async getTrueUpTollingPriceByMonth(body, callback){
        await genericService.get(urls.TRUE_UP_TOLLING_PRICE_HEADER, body).then(callback);
    },
    async updatetTrueUpTollingPriceDetail(body, callback){
        await genericService.put(urls.TRUE_UP_TOLLING_PRICE_DETAILS, body).then(callback);
    },
    async getTrueUpTollingPriceDetailById(id, callback){
        await genericService.getItem(urls.TRUE_UP_TOLLING_PRICE_DETAILS, id).then(callback);
    },
    async getTrueUpTollingDetails(body, callback){
        await genericService.get(urls.TRUE_UP_TOLLING_PRICE_DETAILS, body).then(callback);
    },
    async getTrueUpTollingPriceHeaderCombo(body, callback){
        await genericService.get(urls.TRUE_UP_TOLLING_PRICE_COMBO, body).then(callback);
    },
    async getTrueUpTollingPriceHeaderById(id, callback){
        await genericService.getItem(urls.TRUE_UP_TOLLING_PRICE_HEADER, id).then(callback);
    },
     async updateTrueUpTollingPriceHeaderById(body, callback){
        await genericService.put(urls.TRUE_UP_TOLLING_PRICE_HEADER, body).then(callback);
    },
    async addTrueUpTollingPriceHeader(body, callback){
        await genericService.post(urls.TRUE_UP_TOLLING_PRICE_HEADER, body).then(callback);
    },
    async exportTrueUpTollingPrice(body, callback){
        await genericService.dowloadFile(urls.TRUE_UP_TOLLING_PRICE_EXPORT_EXCEL, body).then(callback);
    },
    async weightedAverageTrueUpTollingPrice(body, callback){
        await genericService.get(urls.TRUE_UP_TOLLING_PRICE_WEIGHTED_AVG_TOLLING_PRICE, body).then(callback);
    },
    async getTrueUpTollingPriceHeaderByMonth(body, callback){
        await genericService.get(urls.TRUE_UP_TOLLING_PRICE_HEADER_BY_MONTH, body).then(callback);
    },
    async deleteTollingPriceDetail(id, callback){
        await genericService.delete(urls.TRUE_UP_TOLLING_PRICE_DETAILS, id).then(callback);
	},
    async getCrudeWeightedAverageValueTanks(body, callback){
        await genericService.get(urls.TRUE_UP_CRUDE_WEIGHTED_AVERAGE_VALUE_GET_TANKS, body).then(callback);
    },
    async updateTrueUpCrudeWtdDetail(body, callback){
        await genericService.put(urls.TRUE_UP_CRUDE_WTD_DETAIL, body).then(callback);
	},
    async exportCrudeTollingWeightedAverageValue(body, callback){
        await genericService.dowloadFile(urls.TRUE_UP_CRUDE_TOLLING_AVERAGE_VALUE_EXPORT_EXCEL, body).then(callback);
    },
    async cloneTrueUpTollingPriceHeader(body, callback){
        await genericService.post(urls.TRUE_UP_TOLLING_PRICE_HEADER_CLONE, body).then(callback);
    },
    async getWeeklyDataFromExcel(body, callback){
        await genericService.post(urls.TRUE_UP_PROVISIONAL_INVOICE_GET_DATA_IMPORT_FROM_EXCEL, body).then(callback);
    },
    async importProvisionalInvoiceFromExcel(body, callback){
        await genericService.post(urls.TRUE_UP_PROVISIONAL_INVOICE_IMPORT_FROM_EXCEL, body).then(callback);
    }
}